import styled from 'styled-components';
import { Link } from 'src/viewLayer/components/DesignSystem';

export const InterpolatedLink = styled(Link)`
  position: relative;
  top: -2.5px;
`;
